import { CharacterCount } from '.';
import type { Node as ProseMirrorNode } from 'prosemirror-model';

interface CustomCharacterCountOptions {
   /**
    * The maximum number of characters that should be allowed. Defaults to `0`.
    */
   limit: number | null | undefined;
   /**
    * The mode by which the size is calculated. Defaults to 'textSize'.
    */
   mode: 'textSize' | 'nodeSize';
   minCharacters: number;
}

interface CustomCharacterCountStorage {
   /**
    * Get the number of characters for the current document.
    */
   characters: (options?: { node?: ProseMirrorNode; mode?: 'textSize' | 'nodeSize' }) => number;

   /**
    * Get the number of words for the current document.
    */
   words: (options?: { node?: ProseMirrorNode }) => number;

   minCharacters: number;
   maxCharacters: number;
}

export const CustomCharacterCount = CharacterCount.extend<
   CustomCharacterCountOptions,
   CustomCharacterCountStorage
>({
   addOptions() {
      return {
         ...this.parent?.(),
         minCharacters: 0,
      };
   },
   addStorage() {
      return {
         ...this.parent?.(),
         minCharacters: this.options.minCharacters,
         maxCharacters: this.options.limit,
      };
   },
});
